import React from "react";
import { IUser } from "core/types/base/IUser";
import DataTable from "components/common/DataTable/DataTable";
import AdminsManagementTableColumns from "components/tenants/AdminsManagementTableColumns";

interface TenantAdminsTableProps {
  users: IUser[];
  onSort: (key: string) => void;
  handleDropdownAction: (
    row: IUser,
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    actionKey: string,
  ) => void;
}

const TenantAdminsTable: React.FC<TenantAdminsTableProps> = ({
  users,
  onSort,
  handleDropdownAction,
}) => {
  return (
    <DataTable
      tableData={users}
      tableColumns={AdminsManagementTableColumns({
        handleDropdownAction,
      })}
      onSort={onSort}
      tableClassName="table-striped mb-0"
      classContainer="table-responsive-xl"
    />
  );
};

export default TenantAdminsTable;
